import { useUsuario } from '../../context/usuarioContext';

export default function Permiso({ modulo, permiso, children }) {
  const { tienePermiso } = useUsuario();

  const permisos = Array.isArray(permiso) ? permiso : [permiso];

  const tieneAlguno = permisos.some( p => tienePermiso(modulo, p) );

  if (tieneAlguno) {
    return <>{children}</>;
  }

  return null;
}